import { collection, getDocs, query, where } from 'firebase/firestore';
import { setVar } from '../../functions';

import { getCtData, setData } from '../../project';
import { firestoreOutFlax } from '../../functions/firebase/firebase';

type Tprops = { args: any; pass: {} };

export const listRents = async (props: Tprops) => {
  console.log('Listando Reservas...');

  const selectedUser = getCtData('all.userData.docId');
  const fireInit = getCtData('all.fireInit');

  try {
    const rentsRef = collection(firestoreOutFlax, 'rents');
    const q = query(rentsRef, where('userId', '==', selectedUser));
    const querySnapshot = await getDocs(q);

    const newArray = querySnapshot.docs.map(doc => {
      const data = doc.data();

      let formattedDate: string | null = null;

      if (data?.createdAt?.seconds) {
        const date = new Date(data.createdAt.seconds * 1000);
        formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(
          date.getMonth() + 1
        )
          .toString()
          .padStart(2, '0')}/${date.getFullYear()}`;
      }

      return {
        totalPrice: data?.totalPrice ?? null,
        createdAt: formattedDate,
        bikesList: data?.bikesList ?? [],
      };
    });

    setVar({
      args: props.args,
      pass: {
        keyPath: ['sc.B4C.lists.mainList'],
        value: newArray,
      },
    });
  } catch (error) {
    console.error('Erro ao listar reservas:', error);
  }
};
